import React, { useState } from "react";
import { Link } from "react-router-dom";
import CTAButton from "../components/cta-button";
import WhatsAppButton from "../components/whatsapp-button";
import toast from "react-hot-toast";

const companyInfo = {
  name: "JS Trading Ventures Sdn Bhd",
  ssm: "202301035158",
  contact: "+6018 266 2349",
  email: "contact@jstradventures.co",
  address:
    "No. 136-02, Jalan Adda 7, Taman Adda Heights, 81100 Johor Bahru, Johor",
};

const ContactUs = () => {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("entry.1008530374", form.fullName);
    formData.append("entry.2139399030", form.email);
    formData.append("entry.1145222794", form.phone);
    formData.append("entry.674170097", form.subject);
    formData.append("entry.114090295", form.message);

    try {
      await toast.promise(
        fetch(
          "https://docs.google.com/forms/u/0/d/e/1FAIpQLSdPtYb44443_0tJpQaqbvL1NdKFNUmrdt6-kSo3LyZrBdlA2g/formResponse",
          {
            method: "POST",
            mode: "no-cors",
            body: formData,
          }
        ),
        {
          loading: "Sending...",
          success: "Message sent successfully!",
          error: "Failed to send message. Please try again later.",
        }
      );
      setForm({ fullName: "", email: "", phone: "", subject: "", message: "" });
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <>
      {/* NavBar */}
      <div className="flex justify-between items-center fixed top-0 left-0 w-screen h-auto backdrop-blur py-4 px-12 [&>div]:flex-1 [&>div]:w-full z-[100] max-[900px]:px-6">
        {/* NavBar Start */}
        <div className="flex gap-8 items-center [&>a]:transition-all [&>a]:underline [&>a]:underline-offset-4 [&>a:hover]:font-semibold max-[1000px]:hidden">
          <a href="/">Home</a>
          {/* <a href="#why">Why</a> */}
          {/* <a href="#member_testimonial">Testimonial</a> */}
          <Link className="text-nowrap" to="#">
            Contact Us
          </Link>
          <Link className="text-nowrap" to="/global-website-disclaimer">
            Global Website Disclaimer
          </Link>
        </div>
        {/* NavBar Center */}
        <div className="flex-center max-[900px]:items-start">
          <h1 className="font-semibold text-lg">JS Tradventures</h1>
        </div>
        {/* NavBar End */}
        <div className="flex justify-end">
          <a
            href="https://app.senangpay.my/payment/174953854759"
            target="_blank"
            rel="noreferrer"
          >
            <button className="transition-all border-2 border-black bg-black text-white px-8 py-1 rounded-full hover:bg-white hover:text-black text-nowrap">
              Subscribe <span className="hidden sm:inline">Now</span>
            </button>
          </a>
        </div>
      </div>
      <main className="relative flex-center gap-0 text-[14px] md:text-[16px] lg:text-[16px] min-h-screen">
        <div className="flex flex-col md:flex-row gap-8 w-full max-w-4xl mx-auto pt-32 pb-12 px-4 md:px-0">
          {/* Contact Form */}
          <div className="md:w-1/2 w-full bg-base-100 rounded-xl border p-6 flex flex-col justify-center">
            <h2 className="text-2xl font-bold mb-4">Get in Touch</h2>
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
              <label className="form-control w-full">
                <span className="label-text mb-1">
                  Full Name <span className="text-red-500">*</span>
                </span>
                <input
                  type="text"
                  name="fullName"
                  placeholder="Enter your full name"
                  value={form.fullName}
                  onChange={handleChange}
                  required
                  className="input input-bordered w-full"
                />
              </label>
              <label className="form-control w-full">
                <span className="label-text mb-1">
                  Email <span className="text-red-500">*</span>
                </span>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  value={form.email}
                  onChange={handleChange}
                  required
                  className="input input-bordered w-full"
                />
              </label>
              <label className="form-control w-full">
                <span className="label-text mb-1">
                  Phone Number (+60) <span className="text-red-500">*</span>
                </span>
                <input
                  type="tel"
                  name="phone"
                  placeholder="e.g. 12-3456789"
                  value={form.phone}
                  onChange={handleChange}
                  required
                  className="input input-bordered w-full"
                />
              </label>
              <label className="form-control w-full">
                <span className="label-text mb-1">
                  Subject <span className="text-red-500">*</span>
                </span>
                <input
                  type="text"
                  name="subject"
                  placeholder="General enquiry, technical support, etc"
                  value={form.subject}
                  onChange={handleChange}
                  required
                  className="input input-bordered w-full"
                />
              </label>
              <label className="form-control w-full">
                <span className="label-text mb-1">
                  Message <span className="text-red-500">*</span>
                </span>
                <textarea
                  name="message"
                  placeholder="Please describe your inquiry or the issues you're facing"
                  value={form.message}
                  onChange={handleChange}
                  rows={5}
                  required
                  className="textarea textarea-bordered w-full"
                />
              </label>
              <button
                type="submit"
                className="btn bg-black text-white w-full mt-2"
              >
                Send Message
              </button>
            </form>
          </div>
          {/* Company Info */}
          <div className="md:w-1/2 w-full bg-black text-white rounded-xl shadow-lg p-6 flex flex-col justify-center  mt-8 md:mt-0 pb-24 md:pb-6">
            <div className="flex-center w-full">
              <img
                className="select-none w-36 aspect-square"
                src="/assets/icon/cta-button.svg"
                alt=""
              />
            </div>

            <h2 className="text-2xl font-bold mb-4">Company Information</h2>
            <ul className="space-y-2">
              <li>
                <span className="font-semibold">Company Name:</span> JS Trading
                Ventures Sdn Bhd
              </li>
              <li>
                <span className="font-semibold">Address:</span> No. 136-02,
                Jalan Adda 7, Taman Adda Heights, 81100 Johor Bahru, Johor,
                Malaysia
              </li>
              <li>
                <span className="font-semibold">Email:</span>{" "}
                <a href="mailto:contact@jstradventures.co" className="link">
                  contact@jstradventures.co
                </a>
              </li>
              <li>
                <span className="font-semibold">Phone:</span>{" "}
                <a href="tel:+60182662349" className="link">
                  +60 18-266 2349
                </a>
              </li>
            </ul>
          </div>
        </div>
        {/* Footer */}
        <div className="bg-black text-white w-full max-w-[98%] rounded-custom rounded-b-none p-12 grid grid-cols-2 justify-around items-center gap-4 max-[920px]:p-4 max-[920px]:py-12 max-[920px]:max-w-none !pb-24 relative">
          <div className="flex flex-col items-center md:items-start col-span-2 md:col-span-1">
            <h1 className="text-3xl font-semibold py-12">JS Tradventures</h1>
            <div className="text-sm opacity-80 text-center md:text-left">
              <p className="font-semibold">JS Trading Ventures Sdn Bhd</p>
              <p>No. 136-02, Jalan Adda 7,</p>
              <p>Taman Adda Heights,</p>
              <p>81100 Johor Bahru,</p>
              <p>Johor, Malaysia</p>
              <p>
                Email:{" "}
                <a
                  href="mailto:contact@jstradventures.co"
                  className="underline hover:font-semibold"
                >
                  contact@jstradventures.co
                </a>
              </p>
              <p>
                Phone:{" "}
                <a
                  href="tel:+60182662349"
                  className="underline hover:font-semibold"
                >
                  +60 18-266 2349
                </a>
              </p>
            </div>
          </div>
          <div className="flex flex-row min-w-[50%] justify-around gap-4 max-[768px]:min-w-full col-span-2 md:col-span-1">
            <div className="flex flex-col gap-2 [&>a]:underline [&>a]:underline-offset-4 [&>a]:pl-1 [&>a:hover]:font-semibold">
              <p className="font-semibold">Navigations</p>
              <a href="/#home">Home</a>
              <a href="/#why">Why Us</a>
              <a href="/#benefit">Benefits</a>
              <a href="/#member_testimonial">Testimonial</a>
              <a href="/#timeline">Timeline</a>
              <a href="/#community">Community</a>
              <Link to="/contact-us">Contact Us</Link>
              <Link to="/global-website-disclaimer">Global Website Disclaimer</Link>
            </div>
            <div className="flex flex-col gap-2 [&>a]:underline [&>a]:underline-offset-4 [&>a]:pl-1 [&>a:hover]:font-semibold">
              <p className="font-semibold">Contact Us</p>
              <a
                target="_BLANK"
                rel={"noreferrer"}
                href="https://discord.gg/9FBtyRpSHw"
              >
                Discord
              </a>
              <a
                target="_BLANK"
                rel={"noreferrer"}
                href="https://www.facebook.com/profile.php?id=61560315221726&mibextid=LQQJ4d"
              >
                Facebook
              </a>
              <a
                target="_BLANK"
                rel={"noreferrer"}
                href="https://www.instagram.com/jstradventures"
              >
                Instagram
              </a>
              <a
                target="_BLANK"
                rel={"noreferrer"}
                href="https://t.me/+h2HVoJhHT004ODA1"
              >
                Telegram
              </a>
              <a
                target="_BLANK"
                rel={"noreferrer"}
                href="https://www.threads.net/@jstradventures"
              >
                Threads
              </a>
              <a
                target="_BLANK"
                rel={"noreferrer"}
                href="https://x.com/JS_Tradventures"
              >
                X (Twitter)
              </a>
              <Link to="/contact-us">Get in Touch</Link>
            </div>
          </div>
          <div className="flex flex-row justify-center items-center opacity-80 flex-wrap text-nowrap col-span-2">
            <Link
              className="p-4 text-current font-light hover:font-bold underline"
              target="_blank"
              to="https://docs.google.com/document/d/13QELt1UIhHPAtrtkrehVy14JlQY10L5JToFUbZHOadw/edit?usp=sharing"
            >
              Privacy Policy
            </Link>
            <p></p>
            <Link
              className="p-4 text-current font-light hover:font-bold underline"
              target="_blank"
              to="https://docs.google.com/document/d/1RenzDKZR-s7O8kRtrCKY6Jq6-5SXAxqbRYB8H1Aasi8/edit?usp=sharing"
            >
              Terms and Conditions
            </Link>
            <Link
              className="p-4 text-current font-light hover:font-bold underline"
              target="_blank"
              to="https://docs.google.com/document/d/1zMrBKDqC4838_Iaud-Wk3Vin1TEfYmw4uPB2_XolPqc/edit?usp=sharing"
            >
              Risk Disclosure Statement
            </Link>
            <Link
              className="p-4 text-current font-light hover:font-bold underline"
              target="_blank"
              to="https://docs.google.com/document/d/1ycFzHFiJDjV9M2d7sFFXkAU1frFC2qxk1kk1-bmSET8/edit?usp=sharing"
            >
              Cookie Policy
            </Link>
          </div>
        </div>

        {/* WhatsApp Floating Button */}
        <WhatsAppButton />
      </main>
    </>
  );
};

export default ContactUs;
